export enum DialingMode {
  PREVIEW = "PREVIEW",
  POWER = "POWER",
  PROGRESSIVE = "PROGRESSIVE",
  PREDICTIVE = "PREDICTIVE",
  AI_AGENT = "AI_AGENT",
}
